'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { Label } from './label';
import { cn } from '../../utils/cn';
import uniqueId from 'lodash/uniqueId';
const RadioGroup = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Root>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>>(({
  className,
  orientation = 'horizontal',
  value,
  ...props
}, ref) => {
  return <div>
      <RadioGroupPrimitive.Root className={cn('inline-grid gap-x-4 gap-y-2', {
      'grid-flow-col': orientation === 'horizontal',
      'grid-flow-row': orientation === 'vertical'
    }, className)} {...props} value={String(value)} ref={ref} />
    </div>;
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>>(({
  className,
  children,
  ...props
}, ref) => {
  return <RadioGroupPrimitive.Item ref={ref} className={cn('aspect-square relative h-4 w-4 rounded-full transition-colors border border-gray-500 hover:border-gray-400 text-gray-800 shadow-sm aria-checked:border-pl-blue-600 aria-checked:bg-pl-blue-600 focus:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-950 disabled:cursor-not-allowed disabled:opacity-50 dark:border-zinc-800 dark:border-zinc-50 dark:text-zinc-50 dark:focus-visible:ring-zinc-300', className)} {...props}>
      <div className="invisible group-hover:visible absolute w-1.75 h-1.75 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 rounded-full" />
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center z-10 relative">
        <div className="w-1.75 h-1.75 bg-white rounded-full" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>;
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
const RadioGroupOption = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  label: string;
}>(({
  className,
  children,
  value,
  id = uniqueId('radio-group-option'),
  label,
  disabled,
  ...props
}, ref) => {
  return <div className="flex group items-center space-x-2 my-1.5">
        <RadioGroupItem className="cursor-pointer" ref={ref} id={id} disabled={disabled} value={value} {...props} />
        <Label htmlFor={id} className={cn('cursor-pointer text-gray-800', {
      'opacity-70': disabled
    })}>
          {label}
        </Label>
      </div>;
});
export { RadioGroup, RadioGroupItem, RadioGroupOption };